import {
  CREATE_ORDER_NEW_RECORD,
  CREATE_ORDER_NEW_RECORD_SUCCESS,
  CREATE_ORDER_NEW_RECORD_ERROR,  
  
  GET_ORDER_NEW_RECORD,
  GET_ORDER_NEW_RECORD_SUCCESS,
  GET_ORDER_NEW_RECORD_ERROR,   

  SET_RECORD_TYPE,
  UPDATE_NEW_RECORD_STATE,

  GET_ORDER_LINEITEMS,
  GET_ORDER_LINEITEMS_SUCCESS,
  GET_ORDER_LINEITEMS_ERROR,
} from "../actions";
import EnumRecordTypes from "../../enums/enumRecordTypes";

const INIT_STATE = {
  isNewRecordPanelShown: false,
  isNewCommentPanelShown: false,
  recordTypeSelected: EnumRecordTypes.Person,
  loading: false,
  error: "",
  record: {},
  orderItemRecord: {},
  orderId: null,
  recordList: {
    records: [],
    pagination: {
      pageNumber: 1,
      pageSize: 5,
      startIndex: 1,
      totalItemCount: 0,
      totalPages: 0,
    },
    selectedRecords: {},
    responseTime: null
  }, 
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
        case GET_ORDER_LINEITEMS:
      return {
        ...state,
        loading: true,
        error: "",
        recordList: null,
        selectedRecordType:
          typeof action.payload.recordType === "string"
            ? getRecordType(action.payload.recordType)
            : action.payload.recordType,
        displayStatus: action.payload.displayStatus,
        pageNumber: action.payload.pageNumber,
        parentRecordId: action.payload.parentRecordId,
        selectedFilters: action.payload.selectedFilters,
        orderId: action.payload.orderId,
        profile: action.payload.profile,
        params: action.payload.params,
        hasUserAccount: action.payload.hasUserAccount ? action.payload.hasUserAccount : ""
      };
    case GET_ORDER_LINEITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        recordList: action.payload,
      };
    case GET_ORDER_LINEITEMS_ERROR:
      const recordList = { ...state.recordList, records: [] };
      recordList.pagination = {
        ...recordList.pagination,
        totalItemCount: 0,
        totalPages: 0,
      };
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        recordList,
      };
    case CREATE_ORDER_NEW_RECORD:
      return { ...state, loading: true, error: "", record: action.payload.newRecord };
    case CREATE_ORDER_NEW_RECORD_SUCCESS:
      return { ...state, loading: false, error: "", record: action.payload, isNewRecordPanelShown: false };
    case CREATE_ORDER_NEW_RECORD_ERROR:
      return { ...state, loading: false, error: action.payload.message };

    case GET_ORDER_NEW_RECORD:
      return { ...state, loading: true, error: "", orderId: action.payload.orderId };
    case GET_ORDER_NEW_RECORD_SUCCESS:
      return { ...state, loading: false, error: "", orderItemRecord: action.payload, isNewRecordPanelShown: false };
    case GET_ORDER_NEW_RECORD_ERROR:
      return { ...state, loading: false, error: action.payload.message };
    case SET_RECORD_TYPE:
      return { ...state, recordTypeSelected: action.payload.recordTypeSelected };
    case UPDATE_NEW_RECORD_STATE:
      return { ...state, ...action.payload.updatedValues }
    default:
      return { ...state };
  }
};

const getRecordType = (recordTypeString) => {
  let recordTypeValue = EnumRecordTypes.Person;
  for (const key in EnumRecordTypes) {
    if (key.toLowerCase() === recordTypeString.toLowerCase()) {
      recordTypeValue = EnumRecordTypes[key];
      break;
    }
  }
  return recordTypeValue;
};
